import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6ke/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6ke/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    sendParams = {
      p_dtereq_st: (typeof searchParams.dtereqst !== 'undefined' ? searchParams.dtereqst : ''),
      p_dtereq_en: (typeof searchParams.dtereqen !== 'undefined' ? searchParams.dtereqen : ''),
      p_codempid_query: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
    }
    return instance().get(endpoint + '/hres6ke/index', { params: sendParams })
  },
  getCreate () {
    if (isMock) return generator(mocker.create())
    return instance().get(endpoint + '/hres6ke/create')
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres6ke/detail/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres6ke/dropdowns')
  },
  postSave (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres6ke/save', saveParams)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres6ke/cancel', cancelParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6ke/index.js